import React from 'react';
import { useParams } from 'react-router-dom';

export default function BookingProcessingPage() {
  const { bookingId } = useParams();

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body p-4 p-md-5 text-center">
              <div className="mb-4">
                <div
                  className="mx-auto d-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-25"
                  style={{ width: 72, height: 72, fontSize: 32 }}
                >
                  ⏳
                </div>
              </div>

              <h1 className="h3 fw-bold mb-3">Réservation en cours de finalisation</h1>

              <p className="text-muted mb-3">Nous avons bien reçu votre paiement.</p>

              <p className="text-muted mb-3">
                Votre réservation est en cours de création auprès de notre système.
              </p>

              <p className="text-muted mb-4">
                Vous recevrez votre confirmation définitive dès que votre dossier sera
                finalisé.
              </p>

              <div className="alert alert-warning text-start">
                <strong>Important :</strong> ne relancez pas un nouveau paiement. Votre
                règlement a déjà été pris en compte.
              </div>

              <div className="small text-muted mt-4">
                Référence dossier : <strong>{bookingId}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
